/* eslint-disable */
// AUTO-GENERATED by scripts/generate-antd-compat-icons.mjs — do not edit by hand.
// Regenerate after changing icon-map.txt: `node scripts/generate-antd-compat-icons.mjs`
import { CustomerServiceOutlined as AntdCustomerServiceOutlined } from '@ant-design/icons'
import { Headset } from 'lucide-react'

import { createIconDispatcher } from '../dispatch'

export default /*#__PURE__*/ createIconDispatcher(
  'customer-service',
  AntdCustomerServiceOutlined,
  Headset
)
